<template>
    <div v-if="localApp" class="p-2">
        <b-tabs content-class="mt-3">

            <!-- TAB 1: BİLGİLER -->
            <b-tab :title="$t('information')" active>
                <b-card no-body class="border mb-3">
                    <b-card-header class="section-header font-weight-bold py-2">
                        {{ $t('personal_information') }}
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-col md="4" class="mb-3">
                                <div class="text-muted small mb-1">{{ $t('name') }}</div>
                                <div class="font-weight-bold">{{ localApp.name }}</div>
                            </b-col>
                            <b-col md="4" class="mb-3">
                                <div class="text-muted small mb-1">{{ $t('surname') }}</div>
                                <div class="font-weight-bold">{{ localApp.surname }}</div>
                            </b-col>
                            <b-col md="4" class="mb-3">
                                <div class="text-muted small mb-1">{{ $t('national_id') }}</div>
                                <div class="font-weight-bold">{{ localApp.national_id }}</div>
                            </b-col>
                            <b-col md="4" class="mb-3">
                                <div class="text-muted small mb-1">{{ $t('date_of_birth') }}</div>
                                <div class="font-weight-bold">{{ localApp.birthdate }}</div>
                            </b-col>
                            <b-col md="4" class="mb-3">
                                <div class="text-muted small mb-1">{{ $t('gender') }}</div>
                                <div class="font-weight-bold">{{ localApp.gender }}</div>
                            </b-col>
                            <b-col md="4" class="mb-3">
                                <div class="text-muted small mb-1">{{ $t('nationality') }}</div>
                                <div class="font-weight-bold">{{ localApp.nationality_code }}</div>
                            </b-col>
                            <b-col md="4" class="mb-3">
                                <div class="text-muted small mb-1">{{ $t('pin_code') }}</div>
                                <div class="font-weight-bold">{{ localApp.pin }}</div>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>

                <b-card no-body class="border">
                    <b-card-header class="section-header font-weight-bold py-2">
                        {{ $t('contact_information') }}
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-col md="4" class="mb-3">
                                <div class="text-muted small mb-1">{{ $t('email') }}</div>
                                <div class="font-weight-bold">{{ localApp.email }}</div>
                            </b-col>
                            <b-col md="4" class="mb-3">
                                <div class="text-muted small mb-1">{{ $t('mobile_number') }}</div>
                                <div class="font-weight-bold">{{ localApp.phone }}</div>
                            </b-col>
                            <b-col md="4" class="mb-3">
                                <div class="text-muted small mb-1">{{ $t('university') }}</div>
                                <div class="font-weight-bold">{{ localApp.home_university_name }}</div>
                            </b-col>
                            <b-col md="4" class="mb-3">
                                <div class="text-muted small mb-1">{{ $t('faculty') }}</div>
                                <div class="font-weight-bold">{{ localApp.home_faculty_name }}</div>
                            </b-col>
                            <b-col md="4" class="mb-3">
                                <div class="text-muted small mb-1">{{ $t('program')}}</div>
                                <div class="font-weight-bold">{{ localApp.home_program_name }}</div>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-tab>

            <!-- TAB 2: PROGRAM SEÇİMİ -->
            <b-tab :title="$t('program_select')">
                <b-card no-body class="border">
                    <b-card-header class="section-header font-weight-bold py-2">
                        {{ $t('program_information') }}
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-col md="4" class="mb-3">
                                <div class="text-muted small mb-1">{{ $t('academic_year') }}</div>
                                <div class="font-weight-bold">{{ localApp.academic_year }}</div>
                            </b-col>
                            <b-col md="4" class="mb-3">
                                <div class="text-muted small mb-1">{{ $t('registration_type') }}</div>
                                <div class="font-weight-bold">{{ localApp.registration_type }}</div>
                            </b-col>
                            <b-col md="4" class="mb-3" v-if="localApp.isGraduate">
                                <div class="text-muted small mb-1">{{ $t('thesis_type') }}</div>
                                <div class="font-weight-bold">{{ localApp.graduate_thesis_type || '-' }}</div>
                            </b-col>
                            <b-col md="4" class="mb-3">
                                <div class="text-muted small mb-1">{{ $t('faculty') }}</div>
                                <div class="font-weight-bold">{{ getLocaleText(localApp, 'bau_faculty_name') }}</div>
                            </b-col>
                            <b-col md="4" class="mb-3">
                                <div class="text-muted small mb-1">{{ $t('program') }}</div>
                                <div class="font-weight-bold">{{ localApp.bau_program_code }} - {{ getLocaleText(localApp, 'bau_program_name') }}</div>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-tab>

            <!-- TAB 3: DERS KAYIT -->
            <b-tab :title="$t('course_registration') || 'Ders Kayıt'">
                <b-card no-body class="border">
                    <b-card-header class="section-header font-weight-bold py-2">
                        {{ $t('selected_courses') }}
                    </b-card-header>
                    <b-card-body class="p-0">
                        <b-table-simple small bordered responsive class="mb-0">
                            <b-thead>
                                <b-tr>
                                    <b-th>{{ $t('course_code') }}</b-th>
                                    <b-th>{{ $t('course_name') }}</b-th>
                                    <b-th>{{ $t('course_type') }}</b-th>
                                    <b-th>{{ $t('section') }}</b-th>
                                    <b-th>{{ $t('credit') }}</b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="(course, idx) in localApp.courses" :key="idx">
                                    <b-td>{{ course.course_code }}</b-td>
                                    <b-td>{{ getLocaleText(course, 'course_name') }}</b-td>
                                    <b-td>{{ getLocaleText(course, 'course_type_name') }}</b-td>
                                    <b-td>{{ course.section }}</b-td>
                                    <b-td>{{ course.credit }}</b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-card-body>
                </b-card>
            </b-tab>

            <!-- TAB 4: BELGELER -->
            <b-tab :title="$t('documents')">
                <b-card no-body class="border">
                    <b-card-header class="section-header font-weight-bold py-2">
                        {{ $t('uploaded_documents') }}
                    </b-card-header>
                    <b-card-body class="p-0">
                        <b-table-simple small bordered responsive class="mb-0">
                            <b-thead>
                                <b-tr>
                                    <b-th>{{ $t('document_name') }}</b-th>
                                    <b-th>{{ $t('document_file') }}</b-th>
                                    <b-th>{{ $t('document_status') }}</b-th>
                                    <b-th>{{ $t('document_description') }}</b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="(doc, idx) in localApp.documents" :key="idx">
                                    <b-td class="align-middle">{{ getLocaleText(doc, 'document_type_name') }}</b-td>
                                    <b-td class="align-middle">
                                        <b-button size="sm" variant="outline-primary" @click="downloadDocument(doc)">
                                            <i class="ri-download-line"></i> {{ $t('download') }}
                                        </b-button>
                                    </b-td>
                                    <b-td class="align-middle">
                                        <b-badge :variant="doc.status === 'approved' ? 'success' : (doc.status === 'rejected' ? 'danger' : 'warning')">
                                            {{ doc.status === 'approved' ? $t('approved') : (doc.status === 'rejected' ? $t('rejected') : $t('status_uploaded')) }}
                                        </b-badge>
                                    </b-td>
                                    <b-td class="align-middle">{{ doc.description || '-' }}</b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-card-body>
                </b-card>
            </b-tab>

        </b-tabs>
    </div>
</template>

<script>
import SpecialStudentApplicationRegisterServices from "@/services/SpecialStudentApplicationRegisterServices";

export default {
    name: "ShowModal",
    props: {
        application: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            localApp: null
        }
    },
    watch: {
        application: {
            immediate: true,
            handler(val) {
                this.localApp = val ? JSON.parse(JSON.stringify(val)) : null;
            }
        }
    },
    methods: {
        statusBadgeClass(status) {
            if (status === 'approved' || status === 'Onaylandı') return 'badge-success';
            if (status === 'rejected' || status === 'Reddedildi') return 'badge-danger';
            return 'badge-warning';
        },
        downloadDocument(doc) {
            const data = {
                document_type: doc.document_type
            };
            SpecialStudentApplicationRegisterServices.showDocuments(doc.id, data)
                .then(response => {
                    this._downloadFile(response, this.getLocaleText(doc, 'document_type_name') + '.' + (response.headers.file_extension ?? 'pdf'));
                })
                .catch(error => {
                    this.showErrors(error, null, true)
                });
        }
    }
}
</script>

<style scoped>
.badge-success { background-color: #28a745; color: white; }
.badge-danger  { background-color: #dc3545; color: white; }
.badge-warning { background-color: #ffc107; color: #212529; }
.section-header {
    background-color: #ffffff;
    color: #212529;
    font-size: 0.85rem;
    letter-spacing: 0.02em;
    border-bottom: 2px solid #dee2e6;
}
</style>
